import React, { PropsWithChildren } from 'react';
import { ClassNameProps } from '@/Types';
import styles from './Icon.scss';
import cn from 'classnames';

type Props = {
  src: string;
  alt: string;
  onClick?: () => void;
  hidden?: boolean;
  disabled?: boolean;
} & ClassNameProps;

export const Icon: React.FC<Props> = ({ src, alt, onClick, hidden, className, disabled }: PropsWithChildren<Props>) => {
  return (
    <img
      className={cn(className, styles.icon, { [styles.icon_disabled]: disabled })}
      src={src}
      alt={alt}
      onClick={onClick}
      hidden={hidden}
    />
  );
};
